import type { Block, ImageRef, Text } from '@ksa/model'
import { SiteImage, SiteText, hasText } from '../context.tsx'

type Props = { image: ImageRef; caption: Text }

export function ImageBlock({ block }: { block: Block }) {
  const p = block.props as unknown as Props
  const bleed = block.variant === 'full-bleed'

  const figure = (
    <figure style={{ margin: 0 }}>
      <SiteImage image={p.image} />
      {hasText(p.caption) && (
        <figcaption className="s-small s-faint" style={{ marginBlockStart: '0.75rem', textAlign: 'center' }}>
          <SiteText value={p.caption} />
        </figcaption>
      )}
    </figure>
  )

  // Full-bleed drops the section's inline padding but keeps its block padding, so an edge-to-edge
  // picture still has air above and below it rather than colliding with the block before it.
  if (bleed) return <section style={{ paddingBlock: 'var(--site-pad)' }}>{figure}</section>

  return (
    <section className="s-section">
      <div className="s-wrap">{figure}</div>
    </section>
  )
}
